import imageStrategy from './imageStrategy.js';
import image from '../../components/Image/index.js';

('use strict');
Object.defineProperty(exports, '__esModule', {
  value: true,
});
var _imageStrategy = _interopRequireDefault(imageStrategy);
var _Image = _interopRequireDefault(image);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var createImageDecorator = function createImageDecorator(config, store) {
  return {
    strategy: (0, _imageStrategy.default)(config, store),
    component: _Image.default,
  };
};
var _default = createImageDecorator;
export default _default;
